import { sendGet } from 'helpers/axios';
import configs from 'config';

export const apiListProjects = (params) => sendGet(`${configs.API_DOMAIN_PROJECT}/api/list-project?disable_paginate=1`, params);
